import React from "react";
import Header from "../../component/header/header";
import Footer from "../../component/footer/footer";
import { motion } from "framer-motion";
import "./demo.css"; // external CSS

const Demo = () => {
  return (
    <div className="demo-page">
      {/* HEADER */}
      <Header />
<section className="demo-hero">
  <div className="container">

    <motion.div
      className="hero-box"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <h1>Startup Deal Demo & Funding Flow</h1>

      <p>
        Explore how startups pitch their ideas, showcase traction,
        validate business models, and present deal flow to investors.
      </p>

      <motion.button
        className="demo-btn"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Start Demo
      </motion.button>
    </motion.div>

  </div>
</section>


      {/* ABOUT DEAL DEMO */}
      <section className="demo-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="demo-box"
          >
            <h2>What is a Deal Demo?</h2>
            <p>
              A deal demo is a comprehensive preview showcasing your startup’s
              value proposition, market opportunity, financial model, and
              traction. It helps investors evaluate your readiness for seed or
              growth funding.
            </p>
          </motion.div>
        </div>
      </section>

      {/* DEMO FLOW STEPS */}
      <section className="demo-steps">
        <div className="container">
          <h2 className="section-title">Deal Demo Flow</h2>

          <div className="row mt-4">
            {[
              {
                title: "1. Startup Overview",
                text: "Founders, mission, vision, and a quick snapshot of the business.",
              },
              {
                title: "2. Market Opportunity",
                text: "Market size, trends, customer segments, and industry insights.",
              },
              {
                title: "3. Product & Solution",
                text: "Your unique product offering and problem-solving approach.",
              },
              {
                title: "4. Business Model",
                text: "Revenue streams, pricing, unit economics, and future scalability.",
              },
              {
                title: "5. Traction & Metrics",
                text: "Sales, users, growth KPIs, achievements, and milestones.",
              },
              {
                title: "6. Financial Projections",
                text: "3–5 year financial growth, forecast, and investment needs.",
              },
              {
                title: "7. Competitor Analysis",
                text: "Market position, competitive advantages, and differentiation.",
              },
              {
                title: "8. Pitch Deck Preview",
                text: "Slides highlighting the core essentials for investors.",
              },
            ].map((item, index) => (
              <div className="col-md-3 col-sm-6 mb-4" key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  className="demo-card"
                >
                  <h4>{item.title}</h4>
                  <p>{item.text}</p>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* IMAGE SECTION */}
      <section className="demo-image-section">
        <div className="container">
          <motion.img
            src="/images/in-3.jpg"
            alt="deal demo"
            className="demo-full-img"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
          />
        </div>
      </section>

      {/* WHY INVEST SECTION */}
      <section className="demo-section">
        <div className="container">
          <motion.div
            className="demo-box"
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2>Why Investors Use Deal Demos?</h2>
            <ul>
              <li>Understand startup viability</li>
              <li>Evaluate revenue growth potential</li>
              <li>Verify market acceptance</li>
              <li>Analyze product strength and team capability</li>
              <li>Review financial performance and projections</li>
            </ul>
          </motion.div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="demo-cta">
        <div className="container text-center">
          <motion.h2
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.7 }}
          >
            Ready to See Your Deal Demo Live?
          </motion.h2>
          <motion.button
            className="demo-btn"
            initial={{ scale: 0.8 }}
            whileInView={{ scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            Book Demo Call
          </motion.button>
        </div>
      </section>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default Demo;
